import { TError } from '../models';

export const filterUncommonErrors = (errors: TError[]) => errors.filter(i => !i.uncommonError);
